import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Header } from '@/components/site/header'
import { Footer } from '@/components/site/footer'
import { PreviewBanner } from '@/components/site/preview-banner'
import { PlayerSpacer } from '@/components/player/player-spacer'

export const Layout: FC<LayoutProps> = ({ children, layout, overlayHeader = false, hideFooterQuote = false }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col bg-background'>
            <a
                href='#main'
                className='sr-only z-[100] rounded-full bg-ivory px-5 py-3 text-sm font-medium text-obsidian focus:not-sr-only focus:fixed focus:left-4 focus:top-4'
            >
                Skip to content
            </a>

            {layout.preview && <PreviewBanner />}

            <Header layout={layout} overlay={overlayHeader} />

            <main id='main' className='flex-1'>
                {children}
            </main>

            <Footer layout={layout} hideQuote={hideFooterQuote} />

            <PlayerSpacer />
        </div>
    )
}
